export default "__VITE_ASSET__8b430f80__"